import React from 'react';
export function Footer() {
  return <footer className="bg-[#050810] text-white pt-20 pb-10" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        {/* Final CTA */}
        <div className="text-center mb-20" data-id="element-69">
          <h2 className="text-3xl md:text-5xl font-display font-bold mb-8" data-id="element-70">
            SUPPORT THE DREAM. <br className="hidden md:block" data-id="element-71" />
            <span className="text-usa-red" data-id="element-72">
              HELP CYRUS KEEP MOVING FORWARD.
            </span>
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-73">
            <a href="#donate" className="bg-usa-red hover:bg-red-700 text-white font-display text-xl px-8 py-4 tracking-wider transition-colors" data-id="element-74">
              SUPPORT CYRUS
            </a>
            <a href="#highlights" className="bg-transparent border-2 border-white hover:bg-white hover:text-usa-navy text-white font-display text-xl px-8 py-4 tracking-wider transition-colors" data-id="element-75">
              WATCH HIS STORY
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-10 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-76">
          <div className="text-center md:text-left" data-id="element-77">
            <span className="font-display text-2xl font-bold tracking-wider block mb-2" data-id="element-78">
              TKD FUTURE
            </span>
            <p className="text-gray-400 text-sm" data-id="element-79">
              Supporting Cyrus Barbour's Taekwondo journey.
            </p>
          </div>

          <div className="text-gray-500 text-sm" data-id="element-80">
            &copy; {new Date().getFullYear()} TKD Future. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}